export default {
  xxxSmall: '0.5rem',
  // 8px
  xxSmall: '0.625rem',
  // 10px
  xSmall: '0.75rem',
  // 12px
  small: '0.875rem',
  // 14px
  default: '1rem',
  // 16px
  medium: '1.125rem',
  // 18px
  xMedium: '1.25rem',
  // 20px
  xxMedium: '1.5rem',
  // 24px
  large: '1.75rem',
  // 28px
  xLarge: '2rem' // 32px
};